<div class="paginator-holder">
  <div class="drop-down" [formGroup]="pageItemsSelect">
    <stc-apps-select-drop-down *ngIf="showPagePerItems" [inputWidth]="'130px'" [labelSize]="14"
      [label]="'Items per page'" [options]="numbers" formControlName="pageSize"
      (selectChange)="handleSelectSize($event)" [outputValue]="'id'">
    </stc-apps-select-drop-down>
  </div>
  <div class="paginator">
    <div class="aiding-text">
      current page : {{activePage}}
    </div>
    <div class="previous-btn">
      <button [ngClass]="{ disabled: onFirstPage }" (click)="goPageByNumber(activePage - 1)">
        Previous
      </button>
    </div>

    <div class="pages-holder">
      @if(!pagesLimitExceeded){ @for(pageNum of [].constructor(pagesCount); let
      i = $index; track pageNum){
      <button type="button" [ngClass]="{ active: activePage === i + 1 }" (click)="goPageByNumber(i + 1)">
        {{ i + 1 }}
      </button>
      } }@else { @for(pageNum of [].constructor(pagesCountLimit); let i =
      $index; track pageNum){
      <button type="button" [ngClass]="{ active: activePage === i + 1 }" (click)="goPageByNumber(i + 1)">
        {{ i + 1 }}
      </button>
      }

      <button type="button" class="more-btn" (click)="toggleRemainingPages()"
        [ngClass]="{ active: activePage > pagesCountLimit && activePage < pagesCount}">
        ... @if (remainingPagesShown) {
        <div class="nums-holder">
          @for (num of [].constructor(pagesCount - pagesCountLimit - 1); let i = $index;track num) {
          <div class="num" [ngClass]="{ active: activePage === i + 1 + pagesCountLimit}"
            (click)="goPageByNumber(i + 1 + pagesCountLimit)">{{ i + 1 + pagesCountLimit }}</div>
          }
        </div>
        }
      </button>

      <button type="button" [ngClass]="{ active: activePage === pagesCount }" (click)="goPageByNumber(pagesCount)">
        {{ pagesCount }}
      </button>
      }
    </div>

    <div class="next-btn">
      <button [ngClass]="{ disabled: onLastPage }" (click)="goPageByNumber(activePage + 1)">
        Next
      </button>
    </div>
  </div>

</div>